import script from "./WageBeforeAfter.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageBeforeAfter.vue?vue&type=script&setup=true&lang=ts"

import "./WageBeforeAfter.vue?vue&type=style&index=0&id=ac6300c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6300c8"]])

export default __exports__